import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import NewLogin from "../../Components/A13/NewLogin/NewLogin";

export default function LoginPage({isAuthenticated}) {

  const [isAuth, setIsAuth] = isAuthenticated;
  let navigate = useNavigate();

  useEffect(() => {
    isAuth
      ? navigate("/Dashboard", {replace: true})
      : navigate("/Login", {replace: true});
  }, [isAuth, navigate]);

  return <NewLogin isAuthenticated={[isAuth, setIsAuth]}/>;
}
